
























import { Component, Mixins, Prop } from "vue-property-decorator";
import { EditingDocument } from "../..";
import { ExternalComment } from "../../../../../domain/document";
import ExternalCommentContent from "./comment/ExternalCommentContent.vue";

@Component({
  components: {
    ExternalCommentContent,
  },
})
export default class CommentTool extends Mixins() {
  @Prop()
  source: EditingDocument;

  get isTemporarySaved(): boolean {
    return this.source
        && this.source.attributes
        && this.source.attributes.isTemporary;
  }

  get hasExternalComment(): boolean {
    return this.source
        && this.source.attributes
        && this.source.attributes.externalComments
        && this.source.attributes.externalComments.length > 0;
  }

  get temporaryNote(): string {
    return (this.isTemporarySaved && this.source.attributes.temporaryNote)
      ? this.source.attributes.temporaryNote
      : "";
  }

  get externalComments(): ExternalComment[] {
    return this.source.attributes.externalComments;
  }
}
